/**
 * Rounded-rectangle mask shapes from SVG paths (Path2D + bbox fit to innerSize).
 * Keys stay rectangle-wide (L) / rectangle-square (M) for saved preferences.
 */

import { RECT_SVG_DISPLAY_SCALE } from './constants'

/** Shape Rec L — large */
export const RECT_L_PATH_D =
  'M586.77,272.2c-87.19-61.45-175.84-65.96-266.18-1.78-2.31,1.64-3.69,4.3-3.75,7.14l-7.38,343.58c-.06,2.94,1.29,5.74,3.67,7.46,83.17,60.32,178.56,65.56,271.82.06,2.38-1.67,3.78-4.41,3.79-7.31l1.81-341.75c.02-2.93-1.38-5.71-3.78-7.4Z'

/** Shape Rec M — medium */
export const RECT_M_PATH_D =
  'M555.78,342.54c-56.06-40.42-113.07-43.39-171.16-1.17-1.49,1.08-2.38,2.83-2.41,4.7l-4.74,226c-.04,1.93.83,3.77,2.36,4.91,53.48,39.68,114.81,43.12,174.78.04,1.53-1.1,2.43-2.9,2.44-4.81l1.17-224.8c0-1.93-.89-3.75-2.43-4.86Z'

const RECT_L_BBOX = {
  minX: 309.4585,
  minY: 224.1988,
  maxX: 590.55,
  maxY: 675.8125,
}

const RECT_M_BBOX = {
  minX: 377.4689,
  minY: 310.965,
  maxX: 558.22,
  maxY: 608.035,
}

function bboxToCfg(bbox, pathD) {
  const { minX, minY, maxX, maxY } = bbox
  const centerX = (minX + maxX) / 2
  const centerY = (minY + maxY) / 2
  const maxDim = Math.max(maxX - minX, maxY - minY)
  return { pathD, minX, minY, maxX, maxY, centerX, centerY, maxDim }
}

const RECT_SVG_CONFIG = {
  'rectangle-wide': bboxToCfg(RECT_L_BBOX, RECT_L_PATH_D),
  'rectangle-square': bboxToCfg(RECT_M_BBOX, RECT_M_PATH_D),
}

const path2dCache = {}

function getRectPath2D(shapeKey) {
  if (!path2dCache[shapeKey]) {
    path2dCache[shapeKey] = new Path2D(RECT_SVG_CONFIG[shapeKey].pathD)
  }
  return path2dCache[shapeKey]
}

function rectSvgTransform(ctx, cx, cy, innerSize, shapeKey) {
  const cfg = RECT_SVG_CONFIG[shapeKey]
  const k = (innerSize / cfg.maxDim) * RECT_SVG_DISPLAY_SCALE
  ctx.setTransform(k, 0, 0, k, cx - k * cfg.centerX, cy - k * cfg.centerY)
}

/**
 * Canvas AABB of the path after bbox-fit (for strip dividers).
 */
export function getRectSvgCanvasBounds(cx, cy, innerSize, shapeKey) {
  const cfg = RECT_SVG_CONFIG[shapeKey]
  const k = (innerSize / cfg.maxDim) * RECT_SVG_DISPLAY_SCALE
  return {
    left: cx + k * (cfg.minX - cfg.centerX),
    right: cx + k * (cfg.maxX - cfg.centerX),
    top: cy + k * (cfg.minY - cfg.centerY),
    bottom: cy + k * (cfg.maxY - cfg.centerY),
  }
}

export function clipToRectSvgPath(ctx, cx, cy, innerSize, shapeKey) {
  rectSvgTransform(ctx, cx, cy, innerSize, shapeKey)
  ctx.clip(getRectPath2D(shapeKey), 'nonzero')
  ctx.setTransform(1, 0, 0, 1, 0, 0)
}

export function strokeRectSvgPath(ctx, cx, cy, innerSize, shapeKey, strokeStyle, lineWidth) {
  const cfg = RECT_SVG_CONFIG[shapeKey]
  const k = (innerSize / cfg.maxDim) * RECT_SVG_DISPLAY_SCALE
  ctx.save()
  ctx.strokeStyle = strokeStyle
  ctx.lineWidth = lineWidth / k
  rectSvgTransform(ctx, cx, cy, innerSize, shapeKey)
  ctx.stroke(getRectPath2D(shapeKey))
  ctx.restore()
}
